<template>
  <tr
    class="cursor-pointer"
    @click="viewLead"
    :class="{ 'disabled-pointer-events': isCallToActionWidget }"
  >
    <!-- Agent Name -->
    <td
      class="truncate-cell"
      style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis"
    >
      <v-avatar color="primary" size="36" class="my-3 mr-2">
        <span class="text-white text-h6">{{ icon }}</span>
      </v-avatar>
      {{ name }}
    </td>

    <!--    <td class="px-0">-->
    <!--      &lt;!&ndash; Name List Tile &ndash;&gt;-->
    <!--      <v-list class="pa-0" style="background-color: transparent">-->
    <!--        <v-list-item>-->
    <!--          <v-row>-->
    <!--            <v-col>-->
    <!--              <v-avatar class="avatar-center" :color="iconColor">-->
    <!--                <span class="text-white text-h6">{{ icon }}</span>-->
    <!--              </v-avatar>-->
    <!--            </v-col>-->
    <!--            <v-col>-->
    <!--              <v-list-item-title-->
    <!--                style="line-height: unset !important"-->
    <!--                class="text-truncate align-center"-->
    <!--              >-->
    <!--                {{ name }}-->
    <!--              </v-list-item-title>-->
    <!--            </v-col>-->
    <!--          </v-row>-->
    <!--        </v-list-item>-->
    <!--        &lt;!&ndash; Status &ndash;&gt;-->
    <!--        <v-list-item class="hidden-md-and-up">-->
    <!--          <v-list-item-title class="text-truncate">-->
    <!--            Funnel Status-->
    <!--          </v-list-item-title>-->
    <!--          <v-list-item-action style="align-items: center">-->
    <!--            {{ status }}-->
    <!--          </v-list-item-action>-->
    <!--        </v-list-item>-->
    <!--        &lt;!&ndash; SMS &ndash;&gt;-->
    <!--        <v-list-item class="hidden-md-and-up">-->
    <!--          <v-list-item-title class="text-truncate"> SMS </v-list-item-title>-->
    <!--          <v-list-item-action>-->
    <!--            <span>-->
    <!--              {{ sms }}-->
    <!--            </span>-->
    <!--          </v-list-item-action>-->
    <!--        </v-list-item>-->
    <!--        &lt;!&ndash; Calls &ndash;&gt;-->
    <!--        <v-list-item class="hidden-md-and-up">-->
    <!--          <v-list-item-title class="text-truncate"> Calls </v-list-item-title>-->
    <!--          <v-list-item-action style="align-items: center">-->
    <!--            {{ calls }}-->
    <!--          </v-list-item-action>-->
    <!--        </v-list-item>-->
    <!--      </v-list>-->
    <!--    </td>-->
    <!-- Status -->
    <td class="pl-1">
      <span class="text-body-1">
        {{ status }}
      </span>
    </td>
    <!-- SMS -->
    <td class="pl-2">
      <span class="text-body-1">{{ sms }}</span>
    </td>
    <!-- Calls -->
    <td class="pl-2">
      <span class="text-body-1">
        {{ calls }}
      </span>
    </td>
  </tr>
</template>

<script>
// import { formatters } from "@/mixins/formatters";
import useFormatters from "@/mixins/formatters";

export default {
  name: "OverviewReferralProgressionListRow",
  // mixins: [formatters],
  props: {
    isCallToActionWidget: {
      type: Boolean,
      default: false,
    },
    lead: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    lead: {
      deep: true,
      immediate: true,
      handler() {
        console.log(this.lead);
      },
    },
  },
  computed: {
    icon() {
      let ln = this.leadName(this.lead);

      if (ln.trim() !== "") {
        return ln.charAt(0).toUpperCase();
      }

      return "-";
    },
    iconColor() {
      return "primary";
    },
    name() {
      let ln = this.leadName(this.lead);

      if (ln.trim() !== "") {
        return ln.trim();
      }

      return "-";
    },
    status() {
      if (this.lead && this.lead.opportunity && this.lead.opportunity.status) {
        return this.prettyPrintEnum(this.lead.opportunity.status);
      }

      return "-";
    },
    sms() {
      if (this.lead && this.lead.opportunity) {
        return this.lead.opportunity.smsCount;
      }

      return "-";
    },
    calls() {
      if (this.lead && this.lead.opportunity) {
        return this.lead.opportunity.phoneCount;
      }

      return "-";
    },
  },
  data() {
    return {};
  },
  methods: {
    ...useFormatters(),
    viewLead() {
      this.$emit("view", this.lead);
    },
  },
};
</script>

<style scoped>
.disabled-pointer-events {
  pointer-events: none;
}
</style>
